import shouldEnableDefaultOnlineMeeting from './shouldEnableDefaultOnlineMeeting';
import { onIsOnlineMeetingChanged } from 'owa-calendar-compose-form-actions';
import { hasAttendees } from 'owa-calendar-event-capabilities';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { getDefaultOnlineMeetingProvider } from 'owa-online-meeting';

/**
 * Enables default online meeting for all the meetings
 * @param event
 */
export default function enableDefaultOnlineMeeting(event: CalendarEvent) {
    if (!shouldEnableDefaultOnlineMeeting(event)) {
        return;
    }

    if (hasAttendees(event)) {
        // Set online meeting only when we have attendees and it's not online already
        if (!event.IsOnlineMeeting) {
            onIsOnlineMeetingChanged(
                true /* IsOnlineMeeting */,
                getDefaultOnlineMeetingProvider(event),
                false /* isOnlineMeetingExplicitlySet */,
                true /* wasOnlineMeetingEverAutoSet */
            );
        }
    } else {
        // Set online meeting back to false if the attendees are removed
        onIsOnlineMeetingChanged(
            false /* IsOnlineMeeting */,
            null /* onlineMeetingProvider */,
            false /* isOnlineMeetingExplicitlySet */,
            false /* wasOnlineMeetingEverAutoSet */
        );
    }
}
